import { useFloating, useClick, useDismiss, useListNavigation, useTypeahead, useInteractions } from "../../node_modules/@floating-ui/react/dist/floating-ui.react.js";
import { useRef, useState, useMemo, useEffect } from "react";
import useControlledState from "../../common/hooks/useControlledState/useControlledState.js";
import { autoUpdate, offset, flip, size, hide } from "../../node_modules/@floating-ui/dom/dist/floating-ui.dom.js";
const useFloatingElement = (props = {}) => {
  var _a;
  const {
    open: controlledOpen,
    setOpen: controlledSetOpen,
    closeOnScroll = false,
    isTypeaheadEnabled = true
  } = props;
  const selectedIndexRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const [open, setOpen] = useControlledState({
    initialState: false,
    value: controlledOpen,
    setValue: controlledSetOpen
  });
  const computedStyles = useMemo(() => {
    return {
      // menuOffset: parseInt(menuOffsetStr) || 0,
      // collisionOffset: parseInt(collisionOffsetStr) || 0,
      menuOffset: 4,
      collisionOffset: 24
    };
  }, []);
  const { refs, context, middlewareData } = useFloating({
    whileElementsMounted: autoUpdate,
    placement: "bottom-start",
    middleware: [
      offset(computedStyles.menuOffset),
      flip({ padding: 0 }),
      size({
        apply: ({ availableWidth, availableHeight, elements }) => {
          Object.assign(elements.floating.style, {
            width: `${elements.reference.getBoundingClientRect().width}px`,
            maxWidth: `${availableWidth}px`,
            maxHeight: `${availableHeight - computedStyles.collisionOffset}px`
          });
        },
        padding: 0
      }),
      hide({
        padding: 0
      })
    ],
    open,
    onOpenChange: setOpen
  });
  useEffect(() => {
    var _a2;
    const hidden = (_a2 = middlewareData.hide) == null ? void 0 : _a2.referenceHidden;
    if (hidden) {
      setOpen(false);
    }
  }, [(_a = middlewareData.hide) == null ? void 0 : _a.referenceHidden, setOpen]);
  const click = useClick(context);
  const dismiss = useDismiss(context, { ancestorScroll: closeOnScroll });
  const optionsRef = useRef([]);
  const labelsRef = useRef([]);
  const listNavigation = useListNavigation(context, {
    listRef: optionsRef,
    activeIndex,
    onNavigate: setActiveIndex,
    selectedIndex: selectedIndexRef.current,
    loop: true
  });
  const typeahead = useTypeahead(context, {
    listRef: labelsRef,
    activeIndex,
    selectedIndex: selectedIndexRef.current,
    onMatch: setActiveIndex,
    enabled: isTypeaheadEnabled
  });
  const { getReferenceProps, getFloatingProps, getItemProps } = useInteractions([
    listNavigation,
    typeahead,
    click,
    dismiss
  ]);
  return {
    context,
    refs,
    optionsRef,
    labelsRef,
    getReferenceProps,
    getFloatingProps,
    getItemProps,
    activeIndex,
    setActiveIndex,
    selectedIndexRef
  };
};
export {
  useFloatingElement as default
};
//# sourceMappingURL=useFloatingElement.js.map
